export default "__VITE_ASSET__jSz6CH6s__"